"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextAlignClass = getTextAlignClass;
exports.getVerticalAlignClass = getVerticalAlignClass;

function getTextAlignClass(align) {
  var textAlignToClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };
  return textAlignToClass[align] || '';
}

function getVerticalAlignClass(align) {
  var verticalAlignToClass = {
    top: 'vertical-top',
    middle: 'vertical-middle',
    bottom: 'vertical-bottom'
  };
  return verticalAlignToClass[align] || '';
}